import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _isEmpty from 'lodash/isEmpty';
export function getClassNames(_ref) {
  var centered = _ref.centered,
    disableNavigation = _ref.disableNavigation,
    stacked = _ref.stacked;
  var classNames = ['fcfm-tabs-container'];
  if (centered) classNames = [].concat(_toConsumableArray(classNames), ['centered']);
  if (stacked) classNames = [].concat(_toConsumableArray(classNames), ['stacked']);
  if (disableNavigation) classNames = [].concat(_toConsumableArray(classNames), ['disable-menu-schedules']);
  return classNames.join(' ');
}
export function getDefaultActiveIndex(schedules, scheduleName) {
  if (_isEmpty(scheduleName)) {
    return 0;
  }
  var index = schedules.findIndex(function (_ref2) {
    var name = _ref2.name;
    return "".concat(name).toLowerCase() === "".concat(scheduleName).toLowerCase();
  });
  // by default the first schedule is active
  return index >= 0 ? index : 0;
}